<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">Tell us more about your Fundraiser</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <form class="form-container m-10" [formGroup]="advanceForm" (ngSubmit)="submit()" autocomplete="off">
    <!-- Description-starts -->
    <div class="title-container">
      <label for="desc"><strong>{{info?.short_description?.placeholder}}</strong></label>
      <app-popover [info]="info?.short_description?.popover"></app-popover>
    </div>
    <mat-form-field class="input-container mt0" appearance="fill">
      <textarea class="text-area" matInput [placeholder]="info?.short_description?.popover?.title"
                formControlName="desc"
                id="desc"
                maxlength="120">
      </textarea>
      <mat-hint align="end">{{desc?.value?.length || 0}}/120</mat-hint>
      <mat-error *ngIf="desc?.invalid">{{info?.fieldRequired}}</mat-error>
    </mat-form-field><!-- Description-ends -->

    <!-- <mat-form-field class="input-container">
      <input matInput appPlaceAutocomplete placeType="(cities)" [placeholder]="info.city.placeholder" formControlName="city" (onSelect)="getPlace($event)">
      <mat-icon class="icon-city" matSuffix></mat-icon>
      <mat-error *ngIf="city.invalid">{{getErrorMessage(city)}}</mat-error>
    </mat-form-field>--> <!-- City-ends -->

    <!-- mobile-starts -->
    <app-intl-input *ngIf="param=='advance'" [control]="mobile" [group]="advanceForm" ></app-intl-input>
    <!-- mobile-ends -->
    <button id="submitBtn3" style="display: none" ></button>
  </form>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <!-- <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()">SAVE AND CONTINUE</button> -->
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{ info?.save_and_continue }}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</mat-card-footer>
